<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Daftar Artikel</h5>
              <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
                    v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button type="submit" class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div class="table-responsive">
              <table class="table align-middle table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th class="w-50 text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Judul Artikel
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-nowrap" scope="col">Segmentasi Usia Kehamilan</th>
                    <th class="text-center" scope="col">Tipe</th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Tanggal
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center" scope="col">
                      <a href="#" class="link-dark">
                        Status
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-end" scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(req, idx) in dataReqNormalized" :key="idx">
                    <th scope="row">{{ idx + 1 }}</th>
                    <td>{{ req.title }}</td>
                    <td>
                      <ul class="nav small flex-column">
                        <li
                          class="text-nowrap"
                          v-for="(item, index) in req.targetVisitorList"
                          :key="index"
                        >
                          <i class="ti ti-point-filled fs-1"></i>
                          {{item}} Minggu
                        </li>
                      </ul>
                    </td>
                    <td class="text-center">
                      <small class="badge fs-1 bg-opacity-75 text-bg-info">{{ req.type || '-' }}</small>
                    </td>
                    <td class="text-center">{{ formatDate(req.createdAt) }}</td>
                    <td class="text-center">
                      <small
                        :class="req.site_status.id == 7 ? 'text-bg-success' : 'text-bg-dark'"
                        class="badge fs-1 bg-opacity-75"
                      >{{ req.site_status.status_name }}</small>
                    </td>

                    <td class="text-nowrap text-end">
                      <router-link
                        :to="`/form-post?id=${req.id}`"
                        class="btn btn-sm btn-outline-primary me-1"
                        title="Ubah"
                      >
                        <i class="ti ti-edit fs-3"></i>
                      </router-link>
                      <a
                        href="#"
                        class="btn btn-sm btn-outline-danger"
                        title="Hapus"
                        @click="deleteData(req.id)"
                      >
                        <i class="ti ti-trash fs-3"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="countDataList"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			order: 'desc',
			page: 1,
			pageSize: 50,
			pageSizes: [10, 20, 50],
			form: {
				id: '',
				title: '',
				content: '',
				attachment: '',
				embed_url: '',
				redirect_url: '',
				target_visitor: '',
				type: 'article',
				statusId: 7
			},
			cariTitle: '',
			formTitle: 'Add New',
			url: 'posts/',
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
		this.$store.dispatch('location/getDataThird', {
			url: `users`,
			params: {
				type: 'patient',
				offset: 0,
				limit: 10000,
				order: 'desc'
			}
		})
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDCLocation',
			countDataList: 'location/getCountDCLocation',
			userList: 'location/getDataThird'
		}),
		dataReqNormalized() {
			if (this.dataList.length > 0) {
				return this.dataList.map((req) => ({
					...req,
					targetVisitorList: (req && req.target_visitor && req.target_visitor !== '00') ? req.target_visitor.split(',').map((s) => s.trim()) : []
				}))
			}
			return []
		}
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getData', {
					url: `posts`,
					params: {
						title: this.cariTitle,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		onSubmit() {
			if (this.form.Notes == '') {
				let toast = this.$toasted.show(`Data tidak lengkap`, {
					theme: 'bubble',
					position: 'top-right',
					duration: 3000
				})
				return
			}
			if (this.file) {
				let formData = new FormData()
				formData.append('upload', this.file)
				this.$store.dispatch('ticket/upload', formData).then((res) => {
					this.storeData(res.images)
				})
			} else {
				this.storeData('')
			}
		},
		storeData(attachment) {
			this.form.attachment = attachment
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form,
					url: this.url,
					method: this.method
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
						var myModalEl = document.getElementById('exampleModal')
						var modal = bootstrap.Modal.getInstance(myModalEl)
						modal.hide()
						this.form = {
							// id: '',

							content: '',
							attachment: '',
							embed_url: '',
							redirect_url: '',
							target_visitor: '',
							type: '',
							statusId: ''
						}
					} else {
					}
				})
		},
		deleteData(id) {
			var conf = confirm('Kamu akan menghapus rekaman ini. Apa kamu yakin?')
			if (conf === false) {
				return
			}

			this.$store
				.dispatch('location/createNewRecord', {
					url: 'posts/' + id,
					method: 'DELETE'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
					} else {
					}
				})
		},
		edit(id) {
			let data = this.dataList.find((o) => o.id === id)
			console.log(data)
			this.form = {
				id: id,
				content: data.content,
				attachment: data.attachment,
				embed_url: data.embed_url,
				redirect_url: data.redirect_url,
				target_visitor: data.target_visitor,
				type: data.type,
				statusId: data.statusId
			}
			this.formTitle = 'Edit'
			this.url = 'posts/' + id
			this.method = 'put'
		},
		add() {
			this.form = {
				id: '',
				content: '',
				attachment: '',
				embed_url: '',
				redirect_url: '',
				target_visitor: '',
				type: '',
				statusId: ''
			}
			this.formTitle = 'Add New'
			this.url = 'posts'
			this.method = 'post'
		},
		formatDate(dateStr) {
			if (!dateStr) return '-' // biar aman kalau null/undefined/kosong
			const d = new Date(dateStr)
			const y = d.getUTCFullYear()
			const m = String(d.getUTCMonth() + 1).padStart(2, '0')
			const day = String(d.getUTCDate()).padStart(2, '0')
			return `${day}/${m}/${y}`
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
